import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useNewOrderMachine from "./hooks/useNewOrderMachine";

const withFastQuoteData = (Component) => (props) => {
  const location = useLocation();

  const [, , { onInitializeForm }] = useNewOrderMachine();

  useEffect(() => {
    location.state && onInitializeForm({ order: location.state });
  }, [location.state, onInitializeForm]);

  return <Component {...props} />;
};

export default withFastQuoteData;
